import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faCartPlus,
    faDollarSign,
    faWallet,
    faClock,
} from '@fortawesome/free-solid-svg-icons';
import Footer from "./Footer";
import Sidebar from "./sidebar";
import Topnav from "./TopNav";
import { API_URL, token } from "./config";

const Dashboard = () => {
    const [stats, setStats] = useState({ total_sales: 0, total_revenue: 0 });
    const [purchases, setPurchases] = useState([]);
    const [withdrawals, setWithdrawals] = useState([]);
    const [balance, setBalance] = useState(0);
    const [show, setShow] = useState(false);

    const toggleSidebar = () => {
        setShow(prevShow => !prevShow);
    };

    useEffect(() => {
        const fetchDashboard = async () => {
            try {
                const response = await fetch(`${API_URL}/authors/dashboard`, {
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                });
                const data = await response.json();
                if (response.ok) {
                    setStats(data.stats);
                    setPurchases(data.purchases || []);
                    setWithdrawals(data.withdrawals || []);
                    setBalance(data.balance || 0);
                } else {
                    console.error('Failed to fetch dashboard');
                }
            } catch (error) {
                console.error('Error fetching dashboard:', error);
            }
        };

        fetchDashboard();
    }, []);

    return (
        <html lang="en">
            <body>
                <div className="wrapper">
                    <Sidebar show={show} />
                    <div className="main-panel">
                        <Topnav toggleSidebar={toggleSidebar} />

                        <div className="container">
                            <div className="page-inner">
                                <div className="row">
                                    <div className="col-sm-6 col-md-3">
                                        <div className="card card-stats card-round">
                                            <div className="card-body">
                                                <div className="row align-items-center">
                                                    <div className="col-icon">
                                                        <div className="icon-big text-center icon-primary bubble-shadow-small">
                                                            <FontAwesomeIcon icon={faCartPlus} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col col-stats ms-3 ms-sm-0">
                                                        <div className="numbers">
                                                            <p className="card-category">Total Sales</p>
                                                            <h4 className="card-title">{stats.total_sales || 0}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-3">
                                        <div className="card card-stats card-round">
                                            <div className="card-body">
                                                <div className="row align-items-center">
                                                    <div className="col-icon">
                                                        <div className="icon-big text-center icon-secondary bubble-shadow-small">
                                                            <FontAwesomeIcon icon={faDollarSign} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col col-stats ms-3 ms-sm-0">
                                                        <div className="numbers">
                                                            <p className="card-category">Revenue</p>
                                                            <h4 className="card-title">${stats.total_revenue || 0}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-3">
                                        <div className="card card-stats card-round">
                                            <div className="card-body">
                                                <div className="row align-items-center">
                                                    <div className="col-icon">
                                                        <div className="icon-big text-center icon-info bubble-shadow-small">
                                                            <FontAwesomeIcon icon={faWallet} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col col-stats ms-3 ms-sm-0">
                                                        <div className="numbers">
                                                            <p className="card-category">Balance</p>
                                                            <h4 className="card-title">${balance || 0}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6 col-md-3">
                                        <div className="card card-stats card-round">
                                            <div className="card-body">
                                                <div className="row align-items-center">
                                                    <div className="col-icon">
                                                        <div className="icon-big text-center icon-warning bubble-shadow-small">
                                                            <FontAwesomeIcon icon={faClock} className="icon-xl" style={{ fontSize: '2.5rem', color: '#fff' }} />
                                                        </div>
                                                    </div>
                                                    <div className="col col-stats ms-3 ms-sm-0">
                                                        <div className="numbers">
                                                            <p className="card-category">Pending Payouts</p>
                                                            <h4 className="card-title">
                                                                ${withdrawals.filter(w => w.status === 'pending').reduce((sum, w) => sum + parseFloat(w.amount), 0)}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <h3 style={{ textAlign: 'left' }}>Recent Purchases</h3>
                                        <div className="card">
                                            <div className="table-responsive pt-3">
                                                <table className="table table-striped events-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Book ID</th>
                                                            {/* <th>Email</th> */}
                                                            <th>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {purchases.slice(0, 10).map((purchase, index) => (
                                                            <tr key={index}>
                                                                <td>{new Date(purchase.purchase_date).toLocaleDateString()}</td>
                                                                <td>{purchase.book_id}</td>
                                                                {/* <td>{purchase.email}</td> */}
                                                                <td>${purchase.amount}</td>
                                                            </tr>
                                                        ))}
                                                        {purchases.length === 0 && (
                                                            <tr><td colSpan="4" className="text-center">No purchases yet</td></tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <footer className="footer">
                            <Footer />
                        </footer>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default Dashboard;